export default __webpack_public_path__ + "static/media/Moderat-Extended-Regular.1565839a.ttf";